
import { defineComponent } from 'vue'
import { request } from './store/case'
import { appConfiguration } from './store/configuration'
import useAppInitialization from '@/composables/use-app-initialization'

export default defineComponent({
  setup() {
    useAppInitialization({ developmentWorkOrderId: '1152737' })

    return {
      request,
      appConfiguration
    }
  }
})
